import { Wand2 } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Switch } from "@/components/ui/switch";

const KEYS = ["cuts", "zooms", "whoosh", "hook", "progress", "endcard"];
export const PRO_ALL = Object.fromEntries(KEYS.map((k) => [k, k !== "whoosh"]));

export const ProPanel = ({ cfg, setCfg }) => {
  const { t } = useI18n();
  const pro = cfg.pro;
  const set = (v) => setCfg((c) => ({ ...c, pro: v }));
  return (
    <div className={`cx-card rounded-xl p-4 sm:p-5 space-y-3 ${pro ? "border-[#a746ff]/50 shadow-[0_0_30px_-12px_rgba(167,70,255,0.8)]" : ""}`} data-testid="pro-panel">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-white font-semibold"><Wand2 className="w-4 h-4 text-[#a746ff]" />{t("pro.title")}</div>
        {pro && <Switch checked onCheckedChange={() => set(null)} data-testid="pro-switch" />}
      </div>
      <p className="text-[11px] text-slate-400">{t("pro.desc")}</p>
      {!pro ? (
        <button onClick={() => set({ ...PRO_ALL })} className="cx-btn w-full rounded-full py-3 text-sm font-semibold" data-testid="pro-enable-btn">{t("pro.btn")}</button>
      ) : (
        <div className="grid gap-2" data-testid="pro-options">
          {KEYS.map((k) => (
            <label key={k} className="flex items-center justify-between gap-3 text-xs text-slate-300 rounded-lg bg-white/[0.03] px-3 py-2">
              {t(`pro.${k}`)}
              <Switch checked={pro[k] ?? PRO_ALL[k]} onCheckedChange={(v) => set({ ...pro, [k]: v })} data-testid={`pro-opt-${k}`} />
            </label>
          ))}
          <p className="text-[10px] text-[#3ad7ff]/80">{t("pro.preview_hint")}</p>
        </div>
      )}
    </div>
  );
};
